// Mapa `slug do módulo no catálogo` → `name da rota inicial daquele módulo`.
// Usado pelo botão "Voltar ao início do módulo" do guia (ver utils/guide-origin.js).
//
// Por que mora aqui e não em cada módulo: o acoplamento slug↔código é problema
// deste módulo (o slug é a chave de lookup do catálogo), e já existe o precedente
// de `utils/welcome-cta-jornada.js` — lógica da Jornada que mora aqui e é
// consumida por 4 módulos de feature. Espalhar o mapa exigiria um registry que
// não existe e tocaria 11 módulos.
//
// Por que `name` e NÃO `path`: um redesign de rota preserva o `name` e quebra o
// `path` — foi exatamente assim que 3 etapas do CRM foram parar em /404 quando o
// PR #1359 reorganizou as rotas (ver utils/feature-gate.js).
//
// ★ Isto é dívida por construção: o mapa apodrece em silêncio se um módulo
// renomear a rota. O teste de invariante (module-routes.unit.js) é o paliativo —
// ele lê os routes.js de verdade e falha se um `name` daqui sumir. A resposta
// durável seria o backend publicar um `overviewRoute` por módulo no catálogo,
// já que ele é dono dos slugs.
const MODULE_KEY_TO_ROUTE = {
  // ★ `carteira.minha` (a tela de CHEGADA), não `carteira` (2026-08-07, bug em
  // tela). `carteira` tem `redirect: '/consolidador/visao_geral'`, e o gate
  // resolve a rota SEGUINDO o redirect — de propósito, é o que o guard faria.
  // Só que o destino é `carteira.overview`, gated por `CONSOLIDATOR_OVERVIEW`,
  // uma feature OPCIONAL. Em escritório sem ela (White Label, sem a aba "Visão
  // Geral"), `moduloBloqueado` derrubava o Consolidador INTEIRO de
  // `modulosVisiveis` — sumia a barra na tela do módulo e o card na Jornada,
  // num módulo que o escritório usa e está aberto na frente do usuário.
  // Aponte sempre para a tela em que a pessoa de fato CAI (`can_show:
  // ASSET_LOCATION`, o mesmo gate do módulo), nunca para uma que redireciona a
  // uma feature opcional — senão o gate mede a tela errada.
  consolidador: 'carteira.minha',
  compliance: 'compliance.overview',
  'clientes-contas': 'clientes',
  crm: 'crm.overview',
  'financial-planning': 'fp.home',
  financeiro: 'finance.overview',
  bi: 'bi.dash',
  'aawz-drive': 'aawz-drive.files',
  'fee-fixo': 'fee-fixo.dashboard',
  // Folha, não o pai `comissoes.visao-geral`: o pai só redireciona, e um push
  // para rota de redirect não é destino confiável.
  comissoes: 'comissoes.visao-geral.overview',
  // ★ Módulos novos (2026-08-07). Folha nos dois, pelo mesmo motivo de Comissões:
  // `task.board` redireciona para `task.board.list`, e `simulador` para
  // `simulador.selecionar`.
  tarefas: 'task.board.list',
  'portfolio-review': 'simulador.selecionar',
  // ★ `asset-allocation` fica DE FORA de propósito. O único destino plausível é
  // /configuracoes/asset-allocation, que é área de Configurações — mandar um
  // profissional não-gestor para lá reintroduz exatamente o /404 que o
  // feature-gate.js foi escrito para consertar. Sem entrada aqui, o botão cai no
  // fluxo de jornada, que sempre existe.
}

// Rota inicial do módulo, ou `null` quando o slug não está mapeado.
// `null` é o sinal para o drawer usar o fluxo de jornada — rótulo E destino.
// Nunca devolver um `name` inventado: `router.push` de nome inexistente lança e
// deixaria o usuário preso com o painel aberto.
export const rotaInicialDoModulo = (moduleKey) =>
  (moduleKey && MODULE_KEY_TO_ROUTE[moduleKey]) || null

// Exportado só para o teste de invariante conferir os `name` contra os routes.js.
export const MAPA_MODULO_ROTA = MODULE_KEY_TO_ROUTE
